// extracted by mini-css-extract-plugin
export default {"addpadding":"addpadding-C27a7","speedProgress":"speedProgress-N4vES","progress":"progress-YVJcH","progressActive":"progressActive-LxYhL"};